import api from 'config/axiosConfig';

export interface UrlMetadata {
  title?: string;
  description?: string;
  image?: any;
  siteName?: string;
}

export const fetchUrlMetadata = async (url: string): Promise<UrlMetadata | null> => {
  try {
    const response = await api.get<UrlMetadata>('/api/utilities/url/metadata', {
      params: { url },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching metadata:', error);
    return null;
  }
};

export const extractNestedUrl = (url: string | any): string | null => {
  // Find all matches of "https://" in the URL.
  // If you also want to catch "http://", use /https?:\/\//g
  const pattern = /https:\/\//g;
  // matchAll returns an iterator; spread (...) converts it to an array
  const allMatches = [...url.matchAll(pattern)];

  // We only care if there is more than one occurrence
  if (allMatches.length > 1) {
    // Get the index of the last occurrence
    const lastIndex = allMatches[allMatches.length - 1].index!;
    // Return everything from that index onward
    return url.slice(lastIndex);
  }

  return null;
};